(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('EquipeDialogController', EquipeDialogController);

    EquipeDialogController.$inject = ['$scope', '$http', '$q', 'entity', '$uibModalInstance', 'Equipe', 'AlertService'];

    function EquipeDialogController($scope, $http, $q, entity, $uibModalInstance, Equipe, AlertService) {
        var vm = this;

        vm.equipe = entity;
        vm.clear = clear;
        vm.save = save;
        vm.buscarUsuarios = buscarUsuarios;
        vm.buscarSistemas = buscarSistemas;
        vm.selecionarUsuario = selecionarUsuario;
        vm.selecionarSistema = selecionarSistema;
        vm.removerUsuario = removerUsuario;
        vm.removerSistema = removerSistema;
        vm.usuarioBusca = null;
        vm.sistemaBusca = null;

        if (!vm.equipe.usuarios) {
            vm.equipe.usuarios = [];
        }
        if (!vm.equipe.sistemas) {
            vm.equipe.sistemas = [];
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.equipe.id !== null) {
                Equipe.update(vm.equipe, onSaveSuccess, onSaveError);
            } else {
                Equipe.save(vm.equipe, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:equipeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error && error.data && error.data.message) {
                AlertService.error(error.data.message);
            }
        }

        function buscarUsuarios(filtro) {
            if (!filtro || filtro.length < 2) {
                return $q.when([]);
            }
            return $http.get('api/users-internos/search', {
                params: { filtro: filtro, page: 0, size: 10 }
            }).then(function (res) {
                var ids = vm.equipe.usuarios.map(function (u) { return u.usuario.id; });
                return res.data.filter(function (u) { return ids.indexOf(u.id) < 0; });
            }, function () {
                return [];
            });
        }

        function buscarSistemas(filtro) {
            if (!filtro || filtro.length < 2) {
                return $q.when([]);
            }
            return $http.get('api/sistemas/search', {
                params: { filtro: filtro, page: 0, size: 10 }
            }).then(function (res) {
                var ids = vm.equipe.sistemas.map(function (s) { return s.id; });
                return res.data.filter(function (s) { return ids.indexOf(s.id) < 0; });
            }, function () {
                return [];
            });
        }

        function selecionarUsuario(item) {
            vm.equipe.usuarios.push({ usuario: item, funcao: 'DESENVOLVEDOR', cargo: null });
            vm.usuarioBusca = null;
        }

        function selecionarSistema(item) {
            vm.equipe.sistemas.push(item);
            vm.sistemaBusca = null;
        }

        function removerUsuario(userEquipe) {
            for (var i = 0; i < vm.equipe.usuarios.length; i++) {
                if (vm.equipe.usuarios[i].usuario.id === userEquipe.usuario.id) {
                    vm.equipe.usuarios.splice(i, 1);
                    return;
                }
            }
        }

        function removerSistema(sistema) {
            for (var i = 0; i < vm.equipe.sistemas.length; i++) {
                if (vm.equipe.sistemas[i].id === sistema.id) {
                    vm.equipe.sistemas.splice(i, 1);
                    return;
                }
            }
        }
    }
})();
